var _mask, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProfileOutline(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "profile_outline",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 200,
    height: 200
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 100,
    r: 99,
    fill: "#008EFF",
    stroke: "#008EFF",
    strokeWidth: 2
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#profile_outline)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 100,
    r: 99,
    fill: "#E0E0E0",
    stroke: "#828282",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#placeholder-2)",
    fill: "#828282"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M178.39 173.759c-1.948-12.628-3.558-17.468-21.181-19.489-6.693-.757-24.908-2.61-31.686-6.482-6.778-3.873-5.719-23.067-5.719-23.067H82.738s1.059 19.236-5.719 23.067c-6.778 3.83-24.993 5.809-31.686 6.482-17.665 2.021-19.275 6.819-21.181 19.489a192.925 192.925 0 00-1.78 23.741H180a202.674 202.674 0 00-1.61-23.741z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.671 146.441c12.243.253 32.915-2.652 41.26-12.838 0-1.768-.211-3.452-.254-4.883v-1.305a8.028 8.028 0 010-1.052v-1.305H82.738s.89 15.616-4.067 21.383z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.934 76.65h-.847c.339-2.82.72-5.556 1.059-8.208 1.779-13.554 5.803-53.248-41.896-53.248S57.575 54.888 59.355 68.442c.339 2.652.677 5.388 1.059 8.209h-.848c-7.243-5.346-7.879 8.418-4.829 13.385a29.01 29.01 0 014.236 8.671c1.102 3.242 2.966 3.663 4.533 3.284 0 1.894.339 3.578.466 4.883.678 7.324 18.385 21.972 22.41 26.56 4.024 4.589 15.723 5.63 17.714 5.546 5.693 0 8.804-1.21 12.362-5.546 3.558-4.335 21.731-19.236 22.409-26.56 0-1.305.254-2.989.466-4.883 1.568.379 3.389 0 4.533-3.284a28.035 28.035 0 014.236-8.67c2.669-4.8 2.076-18.732-5.168-13.387z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.141 93.572s-.678-20.542 1.271-23.74c1.949-3.2 18.724-15.701 20.503-22.773 1.017-4.462-7.074-27.74-7.074-27.74s-22.198 0-22.155 35.022c.71 7.52-1.828 11.235 0 18.567 1.52 5.571 6.55 14.962 7.455 20.664z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.359 93.571s.635-20.541-1.271-23.74c-1.906-3.2-49.732-15.701-51.173-22.773-1.016-4.462-7.074-27.74-7.074-27.74a20.989 20.989 0 0114.191-6.229c22.918-2.904 51.554 3.746 53.121 41.251-.613 7.54 1.98 11.265 0 18.568-1.606 5.566-6.804 14.957-7.794 20.663zM180 197.5a202.674 202.674 0 00-1.61-23.741c-1.948-12.628-3.558-17.469-21.181-19.489a220.728 220.728 0 01-22.621-3.41s-17.198 10.187-33.253 10.229c-16.055.042-33.254-10.229-33.254-10.229a221.493 221.493 0 01-22.664 3.41c-17.664 2.02-19.274 6.819-21.18 19.489a192.93 192.93 0 00-1.864 23.741H180z"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "placeholder-2"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(22.5 12.5)",
    d: "M0 0h157.5v185H0z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileOutline);
export default __webpack_public_path__ + "static/media/profile_outline.47abc0de.svg";
export { ForwardRef as ReactComponent };